//Utils
import 'Scripts/utils/Scroll'
import { isTouchDevice } from 'Scripts/utils/utils'
//Vendor
import Lenis from '@studio-freight/lenis'

//Components
import Preloader from 'Scripts/components/Preloader'
// import Cursor from 'Scripts/components/cursor'
import Transition from 'Scripts/components/Transition'

//Pages
import About from 'Scripts/pages/About'
import Home from 'Scripts/pages/Home'


class App {
  /**
   * @constructor
   */
  constructor() {
    //Variables
    this.template = document.querySelector('body').dataset.page
    this.theme = document.querySelector('body').dataset.theme
    //Developed by
    this.developedBy()
    //is touch device    
    this.isTouch()

    //Methods
    //Listeners
    this.addEventListeners()
    //Smooth Scroll : Lenis
    // this.initSmoothScrolling()
    //Transition
    this.initTransition()
    //Pages
    this.createPage()
     //Preloader
     this.createPreloader()
    //Cursor
    // this.createCursor()
  }

  //Preloader
  createPreloader() {
    this.preloader = new Preloader({
      selector: '#preloader__wrapper',
      counter: '.preloader__counter',
      logo: '.preloader__logo',
    })
  }

  //On siteweb Preloaded
  async onPreloaded() {

    // show Transition page
    await this.transition.show({ color: '#8989FF' })
    //__Hide Preloader
    this.preloader.destroy()
    //Hide transition page
    await this.transition.hide()
    // Show page
    this.page.show()
  }


  //Transition
  initTransition() {
    this.transition = new Transition()
  }

  //Create pages
  createPage() {
    switch (this.template) {
      case 'about':
        this.page = new About()
        break;
      default:
        this.page = new Home()
    }
  }

  //Developed by
  developedBy() {
    console.log("%cDeveloped by Studio-MB : https://embprojects.com", "color:white; font-style: italic; background-color: blue; padding: 5px")

  }

  onResize() {
    if (this.page && this.page.onResize) {
      this.page.onResize()
    }
  }

  onUpdate() {
    if (this.page && this.page.onUpdate) {
      this.page.onUpdate()
    }
  }

  // createCursor() {
  //   this.cursor = new Cursor('.cursor__wrapper')
  // }

  //https://github.com/studio-freight/lenis)
  initSmoothScrolling() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // https://easings.net
      direction: 'vertical',
      smooth: true,
      // smoothTouch: true,
      // touchMultiplier: 2,
    })

    // this.lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
    //   console.log({ scroll, limit, velocity, direction, progress })
    // })

    const scrollFn = (time) => {
      this.lenis.raf(time)
      requestAnimationFrame(scrollFn)
    }
    requestAnimationFrame(scrollFn)
  }

  addEventListeners() {
    window.addEventListener('resize', this.onResize.bind(this))
    window.addEventListener('completed', this.onPreloaded.bind(this))

    // this.lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
    //   // console.log({ scroll, limit, velocity, direction, progress })
    //   this.onScroll({ scroll, limit, velocity, direction, progress })
    // })
  }

  onScroll({ scroll, limit, velocity, direction, progress }) {
    // console.log(this.gallery)
    if (this.gallery && this.gallery.onScroll) {
      this.gallery.onScroll({ scroll, limit, velocity, direction, progress })
    }
  }

  isTouch() {
    isTouchDevice() && document.documentElement.classList.add('isTouchDevice')
  }
  // Loop    
  update() {
    this.page && this.page.update()
    window.requestAnimationFrame(this.update.bind(this))
  }

}

new App()
